import axios from "axios";

interface EnvironmentSettings {
  BASE_URL: string;
  SENTRY_DSN: string;
  PAYMENT_FEE: number;
  RECAPTCHA_ENTERPRISE_SITE_KEY: string;
  FF_ENABLE_TESTING_API: boolean;
  FF_ENABLE_DEMO_SMART_ID: boolean;
}

let settings: EnvironmentSettings;

export async function getSettings() {
  if (!settings) {
    const response = await axios.get<EnvironmentSettings>("/settings.json");
    settings = response.data;
  }

  return settings;
}
